import React, { useCallback, useState } from 'react'
import type { PropsWithChildren } from 'react'
import Snackbar from 'redesign/components/molecules/snackbar'
import SnackbarContext from './context'
import type { SnackbarPartialProps } from './types'

const SnackbarContextProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [snackbarProps, setSnackbarProps] = useState<SnackbarPartialProps | undefined>()
  const [open, setOpen] = useState(false)
  const openSnackbar = useCallback(() => setOpen(true), [])
  const close = useCallback(() => {
    snackbarProps?.onClose?.()
    setOpen(false)
  }, [snackbarProps])

  const action = useCallback(() => {
    snackbarProps?.onAction?.()
    setOpen(false)
  }, [snackbarProps])

  return (
    <SnackbarContext.Provider value={{ setSnackbarProps, openSnackbar }}>
      {snackbarProps && (
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          {...snackbarProps}
          open={open}
          onClose={close}
          onAction={action}
        />
      )}
      {children}
    </SnackbarContext.Provider>
  )
}

export default SnackbarContextProvider
